export default __webpack_public_path__ + "static/media/ECOne.86d1674b.jpg";